import React from "react";
import { Card, Typography, Row, Col } from "antd";
import "./TermsAndConditions.module.css";

const { Title, Paragraph } = Typography;

const TermsAndConditionsPage: React.FC = () => {
  return (
    <div className="terms-conditions-page">
      <Row gutter={[16, 16]} justify="center">
        <Col xs={24} md={20} lg={16}>
          <Card>
            <Title level={1}>Termini e Condizioni</Title>

            <Paragraph>
              L'accesso e l'uso del sito corerare.it e della piattaforma
              associata sono soggetti ai seguenti termini e condizioni.
            </Paragraph>

            <Title level={2}>Proprietà del sito e della piattaforma:</Title>
            <Paragraph>
              Il sito è di proprietà di Università degli Studi di Salerno –
              Dipartimento di Medicina, Chirurgia e Odontoiatria – Scuola Medica
              Salernitana. La piattaforma è sviluppata e concessa in licenza da
              Okkav SRL.
            </Paragraph>

            <Title level={2}>Uso consentito:</Title>
            <Paragraph>
              L'utente si impegna a utilizzare il sito e la piattaforma in
              conformità alla legge e alle regole di correttezza e buona fede,
              evitando qualsiasi uso illecito o dannoso.
            </Paragraph>

            <Title level={2}>Limitazione di responsabilità:</Title>
            <Paragraph>
              Università degli Studi di Salerno e Okkav SRL non sono
              responsabili per eventuali danni derivanti dall'uso improprio del
              sito o della piattaforma.
            </Paragraph>

            <Title level={2}>Proprietà intellettuale:</Title>
            <Paragraph>
              Tutti i contenuti, marchi, software e materiali presenti sul sito
              sono protetti da copyright e diritti di proprietà intellettuale.
              Qualsiasi uso non autorizzato è vietato.
            </Paragraph>

            <Title level={2}>Modifiche:</Title>
            <Paragraph>
              I termini possono essere aggiornati periodicamente. L'utente è
              invitato a consultare regolarmente questa pagina.
            </Paragraph>

            <Title level={2}>Legge applicabile e foro competente:</Title>
            <Paragraph>
              Le presenti condizioni sono regolate dalla legge italiana. Per
              eventuali controversie, il foro competente è quello di Salerno.
            </Paragraph>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default TermsAndConditionsPage;
